'use client';
import Image from 'next/image';
import dynamic from 'next/dynamic';

import HomeLayout from '@/components/Layout/HomeLayout';
import { CookieIcon, X } from 'lucide-react';
import { Footer } from '@/components/Layout/HomeLayout/Footer';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { Box, Button, Modal, Tab, Tabs } from '@mui/material';
import BlackHeader from '@/components/BlackHeader/BlackHeader';
import BlackFooter from '@/components/Footer/Footer';
// Dynamically import both modals
const HowItWorksModalBuyers = dynamic(
  // eslint-disable-next-line no-secrets/no-secrets
  () => import('@/components/HowItWorksModalBuyers/HowItWorksModalBuyers'),
  { ssr: false }, // Disable SSR if it's a client-only component
);

const HowItWorksModalSellers = dynamic(() => import('@/components/HowItWorksModalSellers/HowItWorksModalSellers'), {
  ssr: false,
});
import MobileHeader from '@/components/MobileHeader/MobileHeader';
import UnProtectedRoute from './components/un-protected-route';
import Cookies from './components/cookies/Cookies';
import '@/app/css/app.css';
export default function Home() {
  const router = useRouter();

  const handleCreateClick = () => {
    router.push('/partial-option-landing'); // Redirect to login page if not authenticated
  };
  const handleOkClick = () => {
    router.push('/login-landing'); // Redirect to login page if not authenticated
  };

  const [openHowModal, setOpenHowModal] = React.useState(false);
  const [openCookiesModal, setOpenCookiesModal] = React.useState(false);

  const handleHowModalClose = () => setOpenHowModal(false);
  const Style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
  };

  const [selectedWorkTab, setSelectedWorkTab]: any = React.useState(0);

  const handleWorkTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedWorkTab(newValue);
  };

  const [_activeWorkTab, setActiveWorkTab] = useState('buyers');
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      {' '}
      {
        <UnProtectedRoute>
          <HomeLayout>
            <div className="w-full h-full flex relative ">
              <div className="main-home w-full flex-col items-center h-full   lg:h-full bg-cover bg-center bg-no-repeat px-3 backgroundImage">
                <BlackHeader />

                <div className=" flex lg:hidden">
                  <MobileHeader color="text-white" />
                </div>

                {/* Content goes here */}
                <div className="w-full  flex lg:hidden justify-between px-4    bg-transparent  my-4 z-30 ">
                  <Image
                    src="/whiteLogo.png"
                    alt="Expomore"
                    width={100}
                    height={100}
                    className="  w-[130px] h-[40px]"
                  />
                </div>

                <div className="flex h-f justify-start sm:justify-center md:justify-center lg:justify-center items-center flex-col mt-0 sm:mt-0  md:mt-0  h-[80%] ">
                  <h1 className=" main-heading max-w-[90vw] sm:max-w-[57vw] md:max-w-[57vw] lg:max-w-[57vw] text-white  px-[10px]  text-[24px] sm:text-[18px] md:text-[30px] lg:text-[46px]  font-bold text-start sm:text-center md:text-center lg:text-center  md:leading-[32px] lg:leading-[47px]	">
                    Stop downloading and juggling apps, searching the web, booking appointments and waiting on hold!
                  </h1>

                  <p className=" submain-heading px-[10px]  max-w-[90vw] sm:max-w-[57vw] md:max-w-[57vw] lg:max-w-[57vw] text-white text-[13px] sm:text-[15px] md:text-[24px]  lg:text-[24px]  mt-2 sm:mt-3 md:lg-6 lg:mt-6 text-start sm:text-center md:text-center lg:text-center sm:leading-[18px]  md:leading-[26px] lg:leading-[27px]">
                    EXPOMORE is your all-in-one solution: a personal assistant, safety net, learning companion,
                    interactive shopping buddy, instant income generator, rapid-employment platform, and free customer
                    lead generator for your business.
                  </p>

                  {
                    <div className=" max-w-[90%]  my-5  flex-wrap sm:flex-nowrap md:flex-nowrap lg:flex-nowrap hidden sm:flex md:flex lg:flex w-full  justify-between ">
                      <Button
                        onClick={() => {
                          setOpenHowModal(true);
                        }}
                        className="jobworkbtn me-2 py-4 hidden sm:flex md:flex lg:flex  w-full justify-center bg-[#000] text-white  hover:bg-white hover:border-black hover:text-black mt-8"
                      >
                        <div className="flex flex-col justify-center items-center w-full ">
                          <h1 className="text-start normal-case z-[99] font-bold sm:text-[11px]  md:text-[12px] lg:text-[15px] ">
                            How EXPOMORE work
                          </h1>
                          <div className="dots_border"></div>
                        </div>
                      </Button>
                      <Button
                        onClick={handleCreateClick}
                        style={{ border: '2px solid white' }}
                        className="  me-1   flex px-3  rounded-lg   justify-between  hover:bg-white  hover:border-white hover:text-black  bg-black text-white  w-full mt-8"
                      >
                        <div className="flex flex-col  justify-start  ">
                          <h1 className="text-start   normal-case font-bold sm:text-[11px]  md:text-[12px] lg:text-[15px] ">
                            Signup
                          </h1>
                          <p className="normal-case sm:text-[10px]  md:text-[10px]   lg:text-[12px] font-light ">
                            Create a EXPOMORE account
                          </p>
                        </div>
                      </Button>

                      <Button
                        onClick={handleOkClick}
                        style={{ border: '2px solid white' }}
                        className=" ms-1 lg:ms-2  flex px-3  rounded-lg   justify-between  hover:bg-white  hover:border-white hover:text-black  bg-black text-white  w-full mt-8"
                      >
                        <div className="flex flex-col justify-start ">
                          <h1 className="text-start normal-case  font-bold sm:text-[11px]  md:text-[12px] lg:text-[15px] ">
                            Login
                          </h1>
                          <p className="sm:text-[10px] normal-case md:text-[10px] lg:text-[12px] font-light">
                            Already have a EXPOMORE account
                          </p>
                        </div>
                      </Button>
                    </div>
                  }

                  {/* For android */}

                  <Button
                    style={{ border: '1px solid white' }}
                    onClick={() => {
                      setOpenHowModal(true);
                    }}
                    className="jobworkbtn_mobile sm:hidden md:hidden lg:hidden   flex px-3  py-[5px] md:py-[10px] lg:py-[26px]  justify-between border-2   hover:border-2 hover:border-white   bg-black text-white   w-[94%] mt-4 "
                  >
                    <div className="flex flex-col justify-center w-full  ">
                      <h1 className="normal-case text-center  font-bold text-[11px] text-white z-[99]  md:text-[12px] lg:text-[15px] ">
                        How EXPOMORE works
                      </h1>
                    </div>
                  </Button>

                  {
                    <div className="w-full bg-white text-black pt-0  absolute bottom-0 sm:hidden md:hidden lg:hidden px-2">
                      <div className=" pb-2  flex-wrap sm:flex-nowrap md:flex-nowrap lg:flex-nowrap  sm:hidden md:hidden lg:hidden w-full  justify-between    md:lg-3 lg:mt-3 px-3">
                        <Button
                          onClick={handleCreateClick}
                          className="  h-[55px]  flex px-3  py-[20px] md:py-[20px] lg:py-[26px]  justify-between border-2   hover:border-2 hover:border-white   bg-black text-white   w-full mt-2"
                        >
                          <div className="flex flex-col justify-start  ">
                            <h1 className="text-start normal-case  font-bold sm:text-[11px]  md:text-[12px] lg:text-[15px] ">
                              Signup
                            </h1>
                            <p className=" text-[10px] normal-case md:text-[10px]   lg:text-[12px] font-light ">
                              Create a EXPOMORE account
                            </p>
                          </div>
                        </Button>

                        <Button
                          onClick={handleOkClick}
                          className=" h-[55px] flex px-3 md:py-[20px] lg:py-[26px] justify-between border-2 bg-black text-white  w-full mt-1"
                        >
                          <div className="flex flex-col  justify-start ">
                            <h1 className="text-start normal-case  font-bold sm:text-[11px]  md:text-[12px] lg:text-[15px] ">
                              Login
                            </h1>
                            <p className="text-[10px] normal-case md:text-[10px] lg:text-[12px] font-light">
                              Already have a EXPOMORE account
                            </p>
                          </div>
                        </Button>
                      </div>
                    </div>
                  }
                </div>
              </div>

              {/* Cookies floating button */}
              <div
                onClick={() => {
                  setOpenCookiesModal(true);
                }}
                className="flex absolute left-4 bottom-36 sm:left-4 sm:bottom-12  md:left-4 md:bottom-12 lg:left-4 lg:bottom-12 cursor-pointer bg-white rounded-full  p-3 transition-all duration-300 ease-in-out hover:rotate-45"
              >
                <CookieIcon className="text-gray-500  animate-bounce  sm:animate-none md:animate-none lg:animate-none  h-[15px] w-[15px] sm:h-[30px] sm:w-[30px] md:h-[30px] md:w-[30px] lg:h-[30px] lg:w-[30px]" />
              </div>
            </div>
            {/* )} */}

            {/* Cookies modal */}
            <Cookies
              openCookiesModal={openCookiesModal}
              setOpenCookiesModal={setOpenCookiesModal}
              Style={Style}
              value={value}
              handleChange={handleChange}
            />

            <div className="absolute footer_home bottom-8 left-50">
              <Footer color="text-white" />
            </div>
            <div className="w-full homeFooter absolute bottom-0 ">
              {/* How it works */}
              <Modal
                open={openHowModal}
                onClose={handleHowModalClose} // Handle backdrop clicks
                className="border-0"
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
                disableEscapeKeyDown
                sx={{
                  '& .MuiBackdrop-root': {
                    backdropFilter: 'blur(4px)', // Applying a blur filter to the backdrop
                  },
                }}
              >
                <>
                  <Box
                    sx={{ ...Style, border: 'none', outline: 'none' }}
                    className=" px-2 py-2 h-[97%]  mx-auto w-full max-w-[94%] flex flex-col items-center"
                  >
                    <div className="h-full overflow-hidden ">
                      <Tabs
                        className="mt-4 w-full rounded-xl flex  justify-center items-center"
                        value={selectedWorkTab}
                        onChange={handleWorkTabChange}
                        variant="fullWidth"
                        sx={{
                          '& .MuiTabs-indicator': {
                            display: 'none', // Remove the bottom border (indicator)
                          },
                          '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 600,
                            color: '#000', // Default text color for inactive tabs
                            backgroundColor: 'white', // Default background
                            px: 0, // Padding
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          },
                          '& .Mui-selected': {
                            backgroundColor: '#F3F3F3', // Active tab background
                            color: '#007AFF', // Active tab text color
                            padding: '0px 0px', // Adjust padding
                            borderRadius: '10px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          },
                        }}
                      >
                        <Tab
                          onClick={() => setActiveWorkTab('buyers')}
                          label="For users (buyers)"
                          className="h-[20px] text-[12px] sm:text-sm md:text-sm lg:text-md px-0 sm:px-1 md:px-2 lg:px-2 py-0 max-w-[250px] flex justify-center items-center"
                        />
                        <Tab
                          label="For providers (sellers)"
                          className="text-[12px] sm:text-sm md:text-sm lg:text-md px-1 sm:px-1 md:px-2 lg:px-2 py-0 max-w-[250px] flex justify-center items-center"
                          onClick={() => setActiveWorkTab('sellers')}
                        />
                      </Tabs>

                      <div className="w-full flex justify-center">
                        <div className="flex  w-full flex-col">
                          {/* Scrollable */}
                          <div className="flex flex-col overflow-auto max-h-[80vh]  px-2 sm:px-8  md:px-10 lg:px-12 mt-3">
                            {selectedWorkTab === 0 && <HowItWorksModalBuyers />}

                            {selectedWorkTab === 1 && <HowItWorksModalSellers />}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center justify-center absolute cursor-pointer bg-white h-6 w-6 rounded-full  -top-2 -right-2 lg:-top-2 lg:-right-7">
                      <X
                        onClick={handleHowModalClose}
                        className="transition-transform duration-300 ease-in-out hover:rotate-180"
                      />
                    </div>
                  </Box>
                </>
              </Modal>
              <BlackFooter />
            </div>
          </HomeLayout>
        </UnProtectedRoute>
      }
    </>
  );
}
